import React, { useEffect, useState } from 'react';
import { Carousel } from 'antd';
import { useConfigProvider } from '@/lib/context';
import { imageTransform } from '@/shared/utils/utils';
import { businessSettingsDisplay } from '@/lib/service/common';
import { BusinessSettingConfigKey } from '@/shared/types/business-setting';
import { CreatorReview } from '@/shared/types/ui';
import { LeftOutlined, RightOutlined } from '@/components/Common/Icons';
import Image from 'next/image';
import './index.less';

const ReviewSlides = () => {
  const { isMobile } = useConfigProvider();
  const [reviews, setReviews] = useState<CreatorReview[]>([]);

  useEffect(() => {
    businessSettingsDisplay(BusinessSettingConfigKey.CREATOR_REVIEWS).then((data) => {
      setReviews(data?.value ?? []);
    });
  }, []);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    slidesToScroll: 1,
    draggable: false,
    autoplay: true,
    autoplayTimeout: 2000,
    arrows: true,
    nextArrow: <RightOutlined size={2} />,
    prevArrow: <LeftOutlined size={2} />,
  };

  const renderReviewCard = (review: CreatorReview, index: number) => {
    return (
      <div className="testimonial" key={index}>
        <div className="inner" style={{ backgroundColor: review.color }}>
          <div className="text" style={{ width: !isMobile ? '65%' : '100%' }}>
            <div className="top">
              <div className="name-wrapper">
                {isMobile && (
                  <Image width={50} height={50} src={imageTransform(review.creatorImage, 'compact')} alt={''} />
                )}
                <span className="name">{review.creatorName}</span>
              </div>
              <span className="quote">{review.quote}</span>
            </div>
            {review.featuredOnIcon && (
              <div className="featured-on">
                <span>Featured on</span>
                <Image width={22} height={22} src={imageTransform(review.featuredOnIcon, 'compact')} alt={''} />
              </div>
            )}
          </div>
          {!isMobile && (
            <div className="image-wrapper">
              <Image fill src={imageTransform(review.creatorImage, 'large')} alt={''} />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <Carousel {...sliderSettings} rootClassName="review-slider">
      {reviews.map((review, i) => {
        return renderReviewCard(review, i);
      })}
    </Carousel>
  );
};

export default ReviewSlides;
